import { InjectionToken, Signal } from '@angular/core';
import { Currency } from '@marmon/shared/types/common';

/**
 * Currency of the analysis currently open in the app. Money pipes read this
 * when a template does not pass a currency of its own.
 */
export const ANALYSIS_CURRENCY = new InjectionToken<Signal<Currency>>(
	'ANALYSIS_CURRENCY',
);
